const SYSTEM_TERMINATION_REASON_DATA = [
  { label: "Voluntary resignation", value: "voluntary_resignation" },
  { label: "Laid off", value: "laid_off" },
  { label: "Furlough", value: "furlough" },
  { label: "Role elimination", value: "role_elimination" },
  { label: "Temporary employment ended", value: "temporary_employment_ended" },
  {
    label: "Failed to onboard",
    value: "failed_to_onboard",
    description:
      "Team members dismissed with this reason are excluded from turnover statistics and employment history reports.",
  },
  { label: "Unsatisfactory performance", value: "unsatisfactory_performance" },
  { label: "Violation of company policy", value: "violation_of_company_policy" },
  { label: "Internal transfer: multi-entity organization", value: "internal_transfer" },
  { label: "Retired", value: "retired" },
  { label: "Disabled", value: "disabled" },
  { label: "Deceased", value: "deceased" },
] as const;

export type SystemTerminationReason = (typeof SYSTEM_TERMINATION_REASON_DATA)[number]["value"];

export const SYSTEM_TERMINATION_REASON_OPTIONS: ReadonlyArray<{
  label: string;
  value: SystemTerminationReason;
  description?: string;
}> = SYSTEM_TERMINATION_REASON_DATA;

export const SYSTEM_TERMINATION_REASON_VALUES: ReadonlyArray<SystemTerminationReason> =
  SYSTEM_TERMINATION_REASON_DATA.map((option) => option.value);
